import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useModal from 'hooks/useModal';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import NotificationButton from './NotificationsDropdown';
import SuggestionButton from './SuggestionButton';
import UserProfileDropdown from './UserProfileDropdown';

const WishlistModal = dynamic(
  () => import('components/Wishlist/WishlistModal'),
  { ssr: false }
);

const Navigation = ({ gaEventCategory }) => {
  const { showModal } = useModal();

  const onOpenWishlist = () => {
    sendEvent({ action: 'show_wishlist', category: gaEventCategory });
    showModal(WishlistModal);
  };

  return (
    <div className="flex justify-end">
      <Button
        className="mr-6 w-[177px]"
        data-test-selector="open-wishlist"
        iconLeft={<Icon name="heart-filled" />}
        mobileIcon={<Icon name="heart-filled" />}
        size="size3"
        type="secondary-stroke"
        onClick={onOpenWishlist}
      >
        {placeholder('actions.openWishlist')}
      </Button>
      <SuggestionButton gaEventCategory={gaEventCategory} />
      <NotificationButton gaEventCategory={gaEventCategory} />
      <UserProfileDropdown />
    </div>
  );
};

Navigation.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default Navigation;
